const ruMonths = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
]
const enMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

function formatDate(dateInput: string | Date, lang: 'ru' | 'en'): string {
    const d = new Date(dateInput)
    if (isNaN(d.getTime())) return ''
    const day = String(d.getDate()).padStart(2, '0')
    const months = lang === 'ru' ? ruMonths : enMonths
    const month = months[d.getMonth()]
    const year = d.getFullYear()
    return `${day} ${month} ${year}`
}

export function formatDateRu(dateInput: string | Date): string {
    return formatDate(dateInput, 'ru')
}
export function formatDateEn(dateInput: string | Date): string {
    return formatDate(dateInput, 'en')
}
